import React, { createContext, useContext, useState, useEffect } from 'react';

const WorkbookContext = createContext([]);

export function WorkbookProvider({ children }) {
  const [workbooks, setWorkbooks] = useState([]);

  useEffect(() => {
    fetch('/bilingual_mapping_tool/api/workbooks')
      .then(r => r.json())
      .then(setWorkbooks)
      .catch(console.error);
  }, []);

  return (
    <WorkbookContext.Provider value={workbooks}>
      {children}
    </WorkbookContext.Provider>
  );
}

export const useWorkbooks = () => useContext(WorkbookContext);